import { typography } from '@joor/design-system'
import styled from 'styled-components'

import Table from 'components/Core/Table/Table'

export const StyledTableRow = styled(Table.Row)`
  &&& > td {
    vertical-align: middle;
  }
`

export const TableHeaderCell = styled(Table.Cell)`
  font-weight: 600;
  color: var(--color-primary-600) !important;
  border-bottom: thin solid var(--color-primary-600) !important;
`

export const Container = styled.div`
  margin-top: 14px;
  padding-bottom: 14px;
  background-color: var(--color-secondary-100);
  display: flex;
  flex-direction: column;
  /* sc-247036: with a per-worksheet breakdown, this table can get long
     (one row per linesheet, or several for multi-order sheets). Scroll it
     internally instead of letting the modal grow past the viewport and
     push the step indicator / Back / Close buttons out of view. */
  max-height: 50vh;
  overflow-y: auto;
`

export const ResultCellContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const ButtonLink = styled.button`
  font: ${typography.alpha.primaryActive.body3}
  color: var(--color-secondary-800);
  background: transparent;
  border: none;
  text-decoration: none;
  display: inline-block;
  width: fit-content;
  cursor: pointer
`
